export const generateThumbnail = (videoUrl, isIOS) => {
  if(isIOS) {
      return new Promise((resolve, reject) => {
    const video = document.createElement('video');
    video.src = videoUrl;
    video.crossOrigin = 'anonymous';
    video.muted = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
 
    video.addEventListener('canplay', () => {
      try {
        video.currentTime = Math.min(2, video.duration - 0.1);
      } catch (err) {
        console.error('Seek error:', err);
        reject(err);
      }
    });
 
    video.addEventListener('seeked', () => {
      try {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const thumbnailUrl = canvas.toDataURL('image/jpeg');
        resolve(thumbnailUrl);
      } catch (err) {
        console.error('Thumbnail generation failed:', err);
        reject(err);
      }
    });
 
    video.addEventListener('error', (e) => {
      console.error('Video load error:', e);
      reject(e);
    });
 
    // Start loading explicitly
    video.load();
  });
  }else{
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.src = videoUrl;
      video.muted = true;
      video.crossOrigin = 'anonymous';
      video.addEventListener('loadeddata', () => {
        video.currentTime = 2; // Seek to the 2-second mark (or any other time point)
      });
  
      video.addEventListener('seeked', () => {
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        const thumbnailUrl = canvas.toDataURL('image/jpeg');
        resolve(thumbnailUrl);
      });
  
      video.addEventListener('error', (e) => reject(e));
    });
  }
};


